<template>
  <div class="dash-section">
    <div class="header">
      <div>
        <h2 class="title">Demographics</h2>
      </div>
    </div>
    
    <div v-if="loading" class="skeleton progress pb-5" style="height: 150px">
      <span class="sr-only">Loading Chart</span>
    </div>
    <demographics-chart v-else :demographic-data="demographics" />
  </div>
</template>

<script>
import DemographicsChart from './DemographicsChart.vue';

export default {
  name: 'DemographicsSection',

  components: {
    DemographicsChart
  },

  inject: ['demographicsReport'],

  computed: {
    loading() {
      return this.demographicsReport.loading;
    },

    demographics() {
      return this.demographicsReport.data.demographics;
    }
  }
};
</script>
